import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextM, TextS } from 'frontend/js/modules/infra/dls/components/typography';
import styles from '../styles.module.scss';
import { formatPercentage } from '../../../../../../../app/common/Percentage';
import { shouldShowOpenRate } from '../utils';
import { pluralize } from '../../../../campaign-list/list-view/table/columns/utils';
export var buildOpenRateProps = function (campaign) { return ({
    shouldShow: shouldShowOpenRate(campaign),
    openRate: campaign.openRate,
    userCount: campaign.userCount,
}); };
export var OpenRateColumn = function (_a) {
    var campaign = _a.campaign;
    var props = buildOpenRateProps(campaign);
    if (!props.shouldShow) {
        return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { color: "primary", className: styles.header, children: formatPercentage(0, 2) }), _jsx(TextS, { color: "secondary", children: "0 users" })] }));
    }
    return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { color: "primary", className: styles.header, children: formatPercentage(campaign.openRate, 2) }), _jsx(TextS, { color: "secondary", children: pluralize(campaign.userCount, 'user') })] }));
};
